import { render, staticRenderFns } from "./NewsArea.vue?vue&type=template&id=9e3562fa&"
import script from "./NewsArea.vue?vue&type=script&lang=js&"
export * from "./NewsArea.vue?vue&type=script&lang=js&"
import style0 from "./NewsArea.vue?vue&type=style&index=0&id=9e3562fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator,QInnerLoading,QSpinnerTail})
